import { useMemo, useState } from 'react';

import { useSelector } from 'react-redux';

import {
    LinearProgressBar,
    Paper,
    Stack,
    Typography,
} from '@thirdspacelearning/library';

import LearningObjectiveItem from './LearningObjectiveItem';

import {
    programmeNameSelector,
    programmeSubjectDirectoriesSelector,
} from '@store/programme';

const LOsPanel = () => {
    const subjectDirectories = useSelector(programmeSubjectDirectoriesSelector);
    const programmeName = useSelector(programmeNameSelector);
    const [isAnySessionInitiating, setIsAnySessionInitiating] = useState(false);

    const programmeProgress = useMemo(() => {
        if (subjectDirectories) {
            const objectivesCompleted = subjectDirectories.filter(
                (lo) => lo.completed_at,
            ).length;
            const objectivesTotal = subjectDirectories.length;
            return {
                objectivesCompleted,
                objectivesTotal,
            };
        }

        return null;
    }, [subjectDirectories]);

    return (
        subjectDirectories &&
        programmeProgress && (
            <Paper variant="outlined">
                <Stack
                    spacing={3}
                    sx={{ px: 4, py: 3 }}
                    data-testid="los-panel"
                >
                    <>
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            data-testid="learning-objective-label"
                        >
                            Your Lessons - {programmeName}
                        </Typography>

                        <LinearProgressBar
                            label="LOs completed"
                            aria-label="LOs completed"
                            aria-valuetext={`${programmeProgress?.objectivesCompleted} of ${programmeProgress.objectivesTotal}`}
                            completedCount={
                                programmeProgress?.objectivesCompleted
                            }
                            totalCount={programmeProgress.objectivesTotal}
                        />

                        {subjectDirectories.map((objective) => (
                            <LearningObjectiveItem
                                key={objective.subject_id}
                                lo={objective}
                                isAnySessionInitiating={isAnySessionInitiating}
                                onSessionInitiationChange={
                                    setIsAnySessionInitiating
                                }
                            />
                        ))}
                    </>
                </Stack>
            </Paper>
        )
    );
};

export default LOsPanel;
